<template>
  <div class="dflexc-jcs tao-te-ching-box">
    <tao-nav-panel :allVerses="all_verses"
                   :verse_idx="verse_idx"
      @showall="all_verses = !all_verses"
      @change_verse="change_verse"
      @shuffle="shuffle_index"
      @vIdx="update_vidx"
    />
    <h1 class="tao-te-ching-header">Tao Te Ching</h1>
    <h6 class="by-line">as interpreted by Dr. Wayne Dyer</h6>
    <div class="dflexc-jcs all-verses" v-if="all_verses">
      <div class="tao-box" v-for="tao in tao_index">
        <div class="tao-verse" >
          <h1>Verse #{{ tao.id }}</h1>
        </div>
        <div class="dflexc-jcs tao-verse-box">
          <div class="verse-line" v-for="line in tao.lines">
            {{ line }}
          </div>
        </div>
      </div>
    </div>
    <div class="dflexc-jcs single-verse" v-else>
      <div class="tao-verse" >
        <h1>Verse #{{ current_verse?.id }}</h1>
        <div class="dflexc-jcs tao-verse-box">
          <div class="verse-line" v-for="line in current_verse?.lines">
            {{ line }}
          </div>
        </div>
      </div>
    </div>



  </div>
</template>

<style scoped lang="scss">
$color-primary: #a9a07f;
$color-secondary: #172924;
$color-bg-light: rgba(255, 255, 255, 0.01);
$color-bg-hover: rgba(50, 255, 50, 0.25);
$box-shadow-color: rgb(85, 163, 153);
$font-family-main: "Eagle Lake", serif;
$font-family-secondary: "Charmonman", serif;

.eagle-lake-regular {
  font-family: "Eagle Lake", serif;
  font-weight: 400;
  font-style: normal;
}

.tao-te-ching-box {
  width: 70%;
  max-height: calc(100vh - 100px);
  color: $color-primary;
  margin: 1rem auto;
  box-shadow: 0 0 10px 0 rgb(85, 163, 153);
  background-color: $color-bg-light;
  overflow-y: auto;
  padding-bottom: 1rem;
  font-family: $font-family-secondary;
  font-weight: 600;
  font-style: normal;
  font-size: 1.2rem;

  .tao-te-ching-header {
    font-family: $font-family-main;
    font-weight: 500;
    font-style: normal;
    font-size: 3rem;
    margin: 0;
  }

  .tao-verse h1 {
    color: white;
  }

  .by-line {
    margin: -10px 0 0;
    color: #478c7a;
  }
}
</style>

<script setup>
import {computed, onBeforeMount, ref} from "vue";
import TaoNavPanel from './TaoNavPanel.vue'

const ns_app = window.novasectorapp
const base_url = ns_app.baseURL()

const tao_index = ref("")
const verse_idx = ref(1)

const all_verses = ref(false)
const current_verse = computed( () => {
  return tao_index.value[verse_idx.value - 1]
})

function shuffle_index() {
  const x = Math.floor(Math.random() * 81 + .5)
  verse_idx.value = x;
}

function update_vidx(idx) {
  verse_idx.value = idx
}

function change_verse(val) {
  if(val === 'prev') {
    if(verse_idx.value > 1) {
      verse_idx.value--
    } else {
      verse_idx.value = 81
    }
    all_verses.value = false
  } else if(val === 'next') {
    if(verse_idx.value < tao_index.value.length) {
      verse_idx.value++

    } else {
      verse_idx.value = 1
    }
    all_verses.value = false
  }
}

async function fetch_tao_index() {
  try {
    const x = await fetch(base_url + 'wd_tao_verse/index')
    if(!x.ok) {
      throw new Error('Could not fetch tao index')
    }
    tao_index.value = await x.json()
    console.log('tao index:', tao_index.value)
  } catch (error) {
    console.log('Error fetching tao index', error)
  }
}

onBeforeMount( () => {
  fetch_tao_index()
})
</script>
